export default function DeadlineReasonsCard({ reasons = [] }) {
  return (
    <section className="rules-card deadline-result-section">
      <div className="rules-card-header">
        <div>
          <h3>Motivos retornados</h3>
          <p>Explicações funcionais consideradas pelo motor na resposta.</p>
        </div>
      </div>
      <div className="rules-card-body">
        {reasons.length ? (
          <ul className="deadline-result-list">
            {reasons.map((reason, index) => <li key={`${reason}-${index}`}>{reason}</li>)}
          </ul>
        ) : (
          <p>Nenhum motivo retornado.</p>
        )}
      </div>
    </section>
  )
}
